import type { PixelEvent } from '@/events';

import type { PipelineStage } from '../types';

export class NormalizeStage implements PipelineStage {
  readonly name = 'normalize';

  process(event: PixelEvent): PixelEvent | null {
    return {
      ...event,
      timestamp: event.timestamp ?? Date.now(),
    };
  }
}
